import { NODE_TYPE } from '@/lib/nodeType';

/*
    Запрос за деревом элементов отчета содержит разные параметры.
    Эти параметры зависят от группы.

    На базе insomnia был написан такой словарь. Список групп был взят из файла с категориями.

    TODO: когда решится проблема с разным наименованием, это надо будет удалить.
*/
const hierarchies = {
    organization: {
        [NODE_TYPE.ORGANIZATION]: ['organizationId'],
        [NODE_TYPE.COMPANY]: ['companyId'],
        [NODE_TYPE.FIELD]: ['companyId', 'fieldId'],
        [NODE_TYPE.PAD]: ['padId'],
    },
    field: {
        [NODE_TYPE.FIELD]: ['fieldId'],
        [NODE_TYPE.PAD]: ['padId'],
    },
    area: {
        [NODE_TYPE.AREA]: ['areaId'],
        [NODE_TYPE.FIELD]: ['areaId', 'fieldId'],
        [NODE_TYPE.PAD]: ['padId'],
    },
    license: {
        [NODE_TYPE.ORGANIZATION]: ['organizationId'],
        [NODE_TYPE.COMPANY]: ['companyId'],
        [NODE_TYPE.LICENSE]: ['companyId', 'licenseId'],
        [NODE_TYPE.FIELD]: ['companyId', 'licenseId', 'fieldId'],
    },
    research: {
        [NODE_TYPE.FIELD]: ['fieldId'],
    },
    core: {
        [NODE_TYPE.FIELD]: ['fieldId'],
    },
    testing: {
        [NODE_TYPE.FIELD]: ['fieldId'],
    },
};

/*
    Название на клиенте и бекенде отличаются. Из за чего существует такой словарь соответствий.
*/
const naming = {
    companyId: 'ventureId',
    organizationId: 'orgId',
    fieldId: 'fieldId',
    padId: 'padId',
    areaId: 'areaId',
    licenseId: 'licenseId',
};

/*
    Соотносит параметры, которые должен включать запрос и параметры, которые формирует
    выбранные в дереве элемент (элемент + иерархия родителей).
*/
const formatter = (defaultParams, currentParams) => {
    const result = {};

    for (const param of defaultParams) {
        const name = naming[param];

        result[name] = currentParams[param];
    }

    return result;
};

/*
    Формирование параметров для запроса дерева.
    Параметры формируются согласно следующим полям из модели Tree:

    - groupFilterValue (group)
    - calculationObject (params)
*/
export const settingRequestParams = (group, params) => {
    if (!group && !params) return {};

    const hierarchy = hierarchies[group];

    if (!hierarchy) {
        // eslint-disable-next-line no-console
        console.log(`%c::переданная группа (${group}) не найдена в списке hierarchies`, 'color: #0a8cec;');
        return {};
    }

    const defaultParams = hierarchy[params.node];

    if (!defaultParams) {
        // eslint-disable-next-line no-console
        console.log(
            `%c::переданный node type (${params.node}) не имеет значений параметров по умолчанию`,
            'color: #0a8cec;'
        );
        return {};
    }

    return formatter(defaultParams, params.toParams());
};

/*
    Формирования параметров из списка скважин
*/
export const settingRequestWellParams = listItem => {
    /*
        Если отправить запрос для группы с пустым массивом - будет ошибка.
        Если отправить null - пустое дерево (что лучше вписывается в ожидаемый ответ)
    */
    if (listItem.node === 'group') {
        const wells = listItem.children ?? [];
        const wellIds = wells.map(child => child.id);

        return {
            wellIds: wellIds.length !== 0 ? wellIds : null,
        };
    }

    return {
        wellId: listItem.id,
    };
};
